export const HANDLED_HTTP_STATUS_CODES = [401, 403, 404, 500] // possibility will handle more response
